import React, { useState } from 'react';

const BOT_URL = process.env.REACT_APP_BOT_URL || 'http://localhost:8080';

export default function Settings() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('Sabhi fields fill karein!');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New password aur confirm password match nahi karte!');
      return;
    }

    if (newPassword.length < 4) {
      setError('New password kam se kam 4 characters ka hona chahiye!');
      return;
    }

    setLoading(true);
    try {
      const savedPassword = sessionStorage.getItem('eco_admin_pw') || 'Ecoholic@2025';
      
      const res = await fetch(`${BOT_URL}/api/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          adminPassword: savedPassword,
          currentPassword,
          newPassword
        })
      });

      const data = await res.json();
      if (res.status === 200 && data.success) {
        sessionStorage.setItem('eco_admin_pw', newPassword);
        setMessage('🔑 Password successfully updated!');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        setError(data.error || 'Password update fail ho gaya.');
      }
    } catch (err) {
      setError('Network error. Backend running hai?');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: '500px', margin: '2rem auto' }}>
      <div className="section-header">
        <h2>⚙️ Profile Settings</h2>
      </div>
      <div style={{
        background: 'rgba(255, 255, 255, 0.03)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '16px',
        padding: '2rem',
        marginTop: '1.5rem',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
      }}>
        <h3 style={{ color: '#00a86b', marginBottom: '1.5rem' }}>Change Admin Password</h3>
        
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label style={{ fontSize: '13px', color: '#94a3b8' }}>Current Password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={e => setCurrentPassword(e.target.value)}
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '8px',
                padding: '10px 14px',
                color: '#f8fafc',
                outline: 'none'
              }}
              placeholder="Enter current password"
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label style={{ fontSize: '13px', color: '#94a3b8' }}>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '8px',
                padding: '10px 14px',
                color: '#f8fafc',
                outline: 'none'
              }}
              placeholder="Enter new password"
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label style={{ fontSize: '13px', color: '#94a3b8' }}>Confirm New Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '8px',
                padding: '10px 14px',
                color: '#f8fafc',
                outline: 'none'
              }}
              placeholder="Confirm new password"
            />
          </div>

          {error && <div style={{ color: '#f87171', fontSize: '13px', marginTop: '0.5rem' }}>{error}</div>}
          {message && <div style={{ color: '#34d399', fontSize: '13px', marginTop: '0.5rem' }}>{message}</div>}

          <button
            type="submit"
            disabled={loading}
            style={{
              background: '#00a86b',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '12px',
              fontWeight: '600',
              cursor: 'pointer',
              marginTop: '1rem',
              transition: 'background 0.2s'
            }}
          >
            {loading ? 'Updating Password...' : 'Save Password Changes'}
          </button>
        </form>
      </div>
    </div>
  );
}
